module.exports = "pegasus_template/assets/hexagon-youtube.gif";